import { ChartBarIcon, CurrencyEuroIcon, UserGroupIcon } from "@heroicons/react/24/outline";

import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { FigureRow } from "~/modules/dashboard/components/FigureRow.tsx";
import { useKpiFigures } from "~/modules/dashboard/hooks/useKpiFigures.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";
import { formatPercentage } from "~/utils/numberUtils.ts";

// The personal utilization has a target, so it shows a traffic light: green at or above the target,
// orange up to 10 points below it, red further below. The company figures have no target, so they
// stay neutral. A missing value stays neutral too.
const ORANGE_BAND_POINTS = 10;

function utilisationClassName(percentage: number | null, target: number | null): string {
	if (percentage === null || target === null) {
		return "text-gray-900";
	}
	if (percentage >= target) {
		return "text-success-500";
	}

	return percentage >= target - ORANGE_BAND_POINTS ? "text-orange-500" : "text-danger-500";
}

export function KpiFiguresBox() {
	const { data, isPending, isError } = useKpiFigures();
	const personal = data?.personal;

	return (
		<div>
			<h3 className="mb-3 flex min-h-7 items-center text-lg font-semibold text-gray-900">YTD KPIs</h3>
			<div className="rounded-lg border border-gray-200 bg-white p-3">
				{isPending && <LoadingSpinner theme="neutral" />}
				{isError && <p className="text-sm text-gray-500">Die Kennzahlen konnten nicht geladen werden.</p>}
				{data && (
					<dl>
						{personal && (
							<FigureRow icon={ChartBarIcon}
									   label="Ø Auslastung"
									   value={formatPercentage(personal.yearToDate.utilisationPercentage)}
									   valueClassName={utilisationClassName(
										   personal.yearToDate.utilisationPercentage,
										   personal.utilisationTargetPercentage
									   )} />
						)}
						<FigureRow icon={UserGroupIcon}
								   label='Ø Auslastung NN'
								   value={formatPercentage(data.company.utilisation?.utilisationPercentage ?? null)} />
						<FigureRow icon={CurrencyEuroIcon}
								   label='Ø Tagessatz NN'
								   value={data.company.dailyRate
									   ? formatCentsToCurrency(data.company.dailyRate.averageDailyRateCents, 0)
									   : "–"} />
					</dl>
				)}
			</div>
		</div>
	);
}
